module.exports = __webpack_public_path__ + "static/media/ICBT 2c2.ae479ec7.jpg";